import numeral from 'numeral';

export const formatCurrency = (
  value: string | number | null | undefined,
  showMinus?: boolean,
  showMoney = true
) => {
  const formatString = showMoney ? '$0,0.00' : '0,0.00';
  
  if (showMinus && Number(value) < 0) {
    return `- ${numeral(value || 0).format(formatString)}`;
  }
  
  return numeral(value || 0).format(formatString);
};

export const formatNumber = (value: string | number | null | undefined,) => {
  return numeral(value || 0).format('0,0');
};

export const minusValue = (o: number) => {
  if (o <= 0) return '$0.00';
  return `-${formatCurrency(o)}`;
};

// @ts-ignore
export const parseDecimal = (num: number | undefined | null) => +((+(num || 0)?.toString()?.match(/^-?\d+(?:\.\d{0,2})?/)?.[0])?.toFixed(2) || 0);